import { render, staticRenderFns } from "./PlanCategoryButtons.vue?vue&type=template&id=087d34b9&scoped=true&"
import script from "./PlanCategoryButtons.vue?vue&type=script&lang=js&"
export * from "./PlanCategoryButtons.vue?vue&type=script&lang=js&"
import style0 from "./PlanCategoryButtons.vue?vue&type=style&index=0&id=087d34b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d34b9",
  null
  
)

component.options.__file = "PlanCategoryButtons.vue"
export default component.exports